
/**
 * Empathy InterfaceX Integration
 * Additional helper functions and event handlers
 */

// Web app splash screen
(function () {
  if (!document.documentElement.classList.contains('brn-standalone')) return;
  const splash = document.getElementById('brn-splash');
  if (!splash) return;
  function hideSplash() {
    splash.classList.add('is-hiding');
    setTimeout(function () { splash.style.display = 'none'; splash.classList.remove('is-hiding'); }, 300);
  }
  if (document.readyState !== 'loading') {
    hideSplash();
  } else {
    document.addEventListener('DOMContentLoaded', hideSplash);
  }
})();

// Empathy: fire addProductToCart on every successful cart add
subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
  const ADD_SOURCES = ['product-form', 'pdp', 'sheet-size', 'wishlist', 'gift-drawer', 'quick-add'];
  if (!ADD_SOURCES.includes(event.source)) return;
  if (typeof InterfaceX !== 'undefined' && typeof InterfaceX.addProductToCart === 'function') {
    InterfaceX.addProductToCart();
  }
});

// Quickbuy datalayer tracking — fires only in sections with data-quickbuy-tracking="true"
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.add__to__cart, .variant-elem');
  if (!btn) return;
  if (!btn.closest('[data-quickbuy-tracking]')) return;
  const imageDiv = btn.closest('.brn-card__image');
  const productTitle = imageDiv?.dataset.productTitle
    || btn.closest('.brn-card')?.querySelector('.brn-card__title')?.textContent.trim()
    || '';
  if (window.analyticsUtils?.handleQuickbuyClick) {
    window.analyticsUtils.handleQuickbuyClick(productTitle);
  }
});

// Wait for Empathy InterfaceX to be loaded
window.addEventListener('DOMContentLoaded', function () {
  // Efficiently track when InterfaceX is loaded using event or Promise
  function onInterfaceXReady() {
    // Optional: Add custom event listeners or modifications here
  }

  if (typeof InterfaceX !== 'undefined') {
    // InterfaceX is already loaded
    onInterfaceXReady();
  } else {
    // Listen for a custom event dispatched when InterfaceX is ready
    window.addEventListener('interfaceXReady', onInterfaceXReady, { once: true });

    // Fallback: Promise-based detection if event is not dispatched
    window.interfaceXReadyPromise = new Promise(resolve => {
      const check = setInterval(() => {
        if (typeof InterfaceX !== 'undefined') {
          clearInterval(check);
          onInterfaceXReady();
          resolve();
        }
      }, 300); // Less frequent polling as a fallback

      // Stop checking after 10 seconds
      setTimeout(() => clearInterval(check), 10000);
    });
  }

  initTextSliders();
});

function initTextSliders() {
  const sliders = document.querySelectorAll('.text-slider');
  sliders.forEach(slider => {
    const list = slider.querySelector('ul');
    if (!list) return;

    const items = Array.from(list.querySelectorAll('li'));
    if (items.length <= 1) return;

    // Initial state
    items.forEach((item, index) => {
      if (index === 0) item.classList.add('active');
    });

    let currentIndex = 0;

    setInterval(() => {
      const currentItem = items[currentIndex];
      currentIndex = (currentIndex + 1) % items.length;
      const nextItem = items[currentIndex];

      // Sequence:
      // 1. Current exits (downwards fade out)
      currentItem.classList.remove('active');
      currentItem.classList.add('exit');

      // 2. Next enters (from top fade in)
      nextItem.classList.add('active');

      // 3. Cleanup exit class after transition
      setTimeout(() => {
        currentItem.classList.remove('exit');
      }, 500); // Match CSS transition duration

    }, 3000);
  });
}

// Enhanced close function with visual cleanup
if (typeof window.closeEmpathySearch === 'undefined') {
  window.closeEmpathySearch = function () {
    // Add any custom cleanup logic here
    // For example: hide overlays, reset states, etc.
  };
}

// Fallback for openEmpathySearch if not loaded from snippet
if (typeof window.openEmpathySearch === 'undefined') {
  window.openEmpathySearch = function () {
    if (typeof InterfaceX !== 'undefined' && InterfaceX.search) {
      InterfaceX.search();
    } else {
      console.warn('InterfaceX not loaded yet. Please wait...');
    }
  };
}

function initializeAnimations() {
  // collection-list.liquid animation
  const collectionListObserverOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3,
    trackVisibility: true,
    delay: 300,
  };

  const collectionListObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('visible');
        collectionListObserver.unobserve(entry.target);
      }
    });
  }, collectionListObserverOptions);

  const collectionSections = document.querySelectorAll('.collection-list__container');
  collectionSections.forEach(section => {
    collectionListObserver.observe(section);
  });

  // Banner texts animation
  const texts = document.querySelectorAll('image-banner .line-mask, low-power-video .line-mask');
  const observerText = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observerText.unobserve(entry.target);
        }
      });
    }, {
    // eslint-disable-next-line
    threshold: 0.8
    // eslint-disable-next-line
  }
  );

  texts.forEach(text => observerText.observe(text));
}

function rotateText() {
  const bar = document.querySelector('.bottom-bar');

  if (!bar) {
    return;
  }

  const texts = bar.querySelectorAll('p');
  if (texts.length <= 1) {
    if (texts.length === 1) {
      texts[0].classList.add('active');
    }
    return;
  }

  let currentIndex = 0;
  texts[currentIndex].classList.add('active');

  setInterval(() => {
    texts[currentIndex].classList.remove('active');

    setTimeout(() => {
      currentIndex = (currentIndex + 1) % texts.length;
      texts[currentIndex].classList.add('active');
    }, 500);
  }, 3000);
}

// eslint-disable-next-line no-unused-vars
class ScrollAnimationController {
  constructor(imageContainer, firstImage, secondImage) {
    this.imageContainer = imageContainer;
    this.firstImage = firstImage;
    this.secondImage = secondImage;
    this.containerTop = 0;
    this.containerBottom = 0;
    this.containerHeight = 0;
    this.ticking = false;

    this.currentX1 = 0;
    this.targetX1 = 0;
    this.currentX2 = 100;
    this.targetX2 = 100;

    // smooth value
    this.easing = 0.05;

    this.animationFrameId = null;

    this.init();
  }

  updateContainerBounds() {
    const rect = this.imageContainer.getBoundingClientRect();
    this.containerTop = rect.top + window.scrollY;
    this.containerBottom = this.containerTop + rect.height;
    this.containerHeight = rect.height;
  }

  handleScroll() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;

    this.updateContainerBounds();

    const startTrigger = this.containerTop - windowHeight * 0.3;
    const endTrigger = this.containerBottom - windowHeight * 0.5;
    const totalScrollDistance = endTrigger - startTrigger;

    let scrollProgress = 0;

    if (scrollY > startTrigger && scrollY < endTrigger) {
      scrollProgress = ((scrollY - startTrigger) / totalScrollDistance) * 2;
      scrollProgress = Math.max(0, Math.min(1, scrollProgress));
    } else if (scrollY >= endTrigger) {
      scrollProgress = 1;
    }

    this.targetX1 = -(scrollProgress * 100);
    this.targetX2 = 100 - scrollProgress * 100;
  }

  smoothAnimate() {
    this.currentX1 += (this.targetX1 - this.currentX1) * this.easing;
    this.currentX2 += (this.targetX2 - this.currentX2) * this.easing;

    this.firstImage.style.transform = `translateX(${this.currentX1}%)`;
    this.secondImage.style.transform = `translateX(${this.currentX2}%)`;

    this.animationFrameId = requestAnimationFrame(this.smoothAnimate.bind(this));
  }

  requestScrollUpdate() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.handleScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  init() {
    this.firstImage.style.transform = 'translateX(0%)';
    this.secondImage.style.transform = 'translateX(100%)';

    this.updateContainerBounds();
    this.handleScroll();

    this.boundScrollUpdate = this.requestScrollUpdate.bind(this);
    this.boundHandleResize = this.handleResize.bind(this);

    window.addEventListener('scroll', this.boundScrollUpdate);
    window.addEventListener('resize', this.boundHandleResize);

    this.smoothAnimate();

  }

  handleResize() {
    this.updateContainerBounds();
    this.handleScroll();
  }

  destroy() {
    window.removeEventListener('scroll', this.boundScrollUpdate);
    window.removeEventListener('resize', this.boundHandleResize);
    cancelAnimationFrame(this.animationFrameId);
  }
}


// Wishlist class moved to wishlist.js


document.addEventListener('DOMContentLoaded', () => {
  initializeAnimations();
  rotateText();
});

document.addEventListener('shopify:section:load', () => {
  initializeAnimations();
  rotateText();
});

document.addEventListener('shopify:section:reorder', () => {
  initializeAnimations();
  rotateText();
});


//Newsletter form validation
(function () {

  const forms = document.querySelectorAll('.newsletter-form');

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showError(wrapper, errorElement, errorTextElement, message, submitBtn, isEmailError = false) {
    if (isEmailError) {
      wrapper.classList.add('error');
      if (submitBtn) {
        submitBtn.classList.add('btn-error');
        submitBtn.type = 'button'; // Prevent form submission
      }
    }

    if (errorTextElement) {
      errorTextElement.textContent = message;
    }
    errorElement.style.display = 'block';
  }

  function hideError(wrapper, errorElement, removeErrorClass = true, submitBtn = null, isEmailError = false) {
    if (removeErrorClass && isEmailError) {
      wrapper.classList.remove('error');
      if (submitBtn) {
        submitBtn.classList.remove('btn-error');
        submitBtn.type = 'submit'; // Restore form submission
      }
    }
    errorElement.style.display = 'none';
  }

  forms.forEach(function (form) {
    const wrapper = form.closest('.newsletter__wrapper');
    const emailInput = form.querySelector('[type="email"]');
    const privacyCheckbox = form.querySelector('input[name="contact[privacy_policy]"]');
    const emailError = form.querySelector('[id*="email-error"]:not([id*="text"])');
    const emailErrorText = form.querySelector('[id*="email-error-text"]');
    const privacyError = form.querySelector('[id*="privacy-error"]:not([id*="text"])');
    const privacyErrorText = form.querySelector('[id*="privacy-error-text"]');
    const privacyContainer = form.querySelector('.newsletter__privacy');
    const privacyPolicyWrapper = form.querySelector('[id*="privacy-policy-wrapper"]'); // NEW

    const submitBtn = form.querySelector('.brn-newsletter__btn');

    if (!emailInput || !emailError) return;

    // Check if form was posted successfully via URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const successWrapper = form.querySelector('.newsletter__success-wrapper');

    if (urlParams.get('customer_posted') === 'true' && successWrapper) {
      // Newsletter signup succeeded — surface it through the unified toaster.
      const successText = successWrapper.textContent.trim();
      if (window.toast && successText) {
        window.toast.show(successText, { type: 'success', icon: 'email' });
      }
    }

    // Add click event to X icon to clear error and focus input
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if (this.classList.contains('btn-error') && wrapper.classList.contains('error')) {
          e.preventDefault();
          e.stopPropagation();
          hideError(wrapper, emailError, true, submitBtn, true);
          emailInput.value = ''; // Clear the input
          emailInput.focus();
        }
      });
    }

    // Show privacy checkbox on first focus
    let hasBeenFocused = false;
    emailInput.addEventListener('focus', function () {
      if (!hasBeenFocused && privacyContainer) {
        privacyContainer.style.display = 'block';
        hasBeenFocused = true;
      }
      if (privacyPolicyWrapper) {
        privacyPolicyWrapper.classList.remove('newsletter-form__privacy-policy--hidden');
      }

    }, { once: false });

    emailInput.addEventListener('blur', function (e) {
      // Don't validate on blur if clicking the submit button
      // The submit event will handle validation
      if (e.relatedTarget === submitBtn) {
        return;
      }

      const email = this.value.trim();

      if (email === '') {
        showError(wrapper, emailError, emailErrorText, window.formValidation.requiredEmailStr, submitBtn, true);
      } else if (!isValidEmail(email)) {
        showError(wrapper, emailError, emailErrorText, window.formValidation.validEmailStr, submitBtn, true);
      } else {
        hideError(wrapper, emailError, true, submitBtn, true);
      }
    });

    emailInput.addEventListener('input', function () {
      const email = this.value.trim();

      if (email !== '' && isValidEmail(email)) {
        hideError(wrapper, emailError, true, submitBtn, true);
      }
    });

    if (privacyCheckbox && privacyError) {
      privacyCheckbox.addEventListener('change', function () {
        if (this.checked) {
          hideError(wrapper, privacyError, true, submitBtn, false);
        }
      });
    }

    form.addEventListener('submit', function (e) {
      const email = emailInput.value.trim();
      let hasErrors = false;

      // Check email errors
      const emailEmpty = email === '';
      const emailInvalid = !emailEmpty && !isValidEmail(email);

      if (emailEmpty || emailInvalid) {
        hasErrors = true;
      }

      // Check privacy checkbox error (only if visible)
      const privacyVisible = (privacyContainer && privacyContainer.style.display !== 'none')
        || (privacyPolicyWrapper && !privacyPolicyWrapper.classList.contains('newsletter-form__privacy-policy--hidden'));

      const privacyUnchecked = privacyVisible && privacyCheckbox && !privacyCheckbox.checked;

      if (privacyUnchecked) {
        hasErrors = true;
      }
      if (!hasErrors) {
        window.analyticsUtils.handleLead();
      }

      // If there are ANY errors, prevent submit
      if (hasErrors) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Show errors
        if (emailEmpty) {
          showError(wrapper, emailError, emailErrorText, window.formValidation.requiredEmailStr, submitBtn, true);
        } else if (emailInvalid) {
          showError(wrapper, emailError, emailErrorText, window.formValidation.validEmailStr, submitBtn, true);
        } else {
          hideError(wrapper, emailError, true, submitBtn, true);
        }

        if (privacyUnchecked && privacyError) {
          showError(wrapper, privacyError, privacyErrorText, window.formValidation.privacyPolicyStr, submitBtn, false);
        } else if (privacyError) {
          hideError(wrapper, privacyError, true, submitBtn, false);
        }

        // Focus on first error
        if (emailEmpty || emailInvalid) {
          emailInput.focus();
        } else if (privacyUnchecked && privacyCheckbox) {
          privacyCheckbox.focus();
        }

        return false;
      }

    });
  });
})();

// @note Loader overlay removido del grid; el contenedor reserva espacio vía aspect-ratio

function watchAndDeleteElements(selector) {
  const processElement = (el) => {
    if (el.dataset.timeoutStarted) return;
    el.dataset.timeoutStarted = "true";
    setTimeout(() => {
      if (el.parentNode) {
        el.remove();
      }
    }, 4000);
  };

  document.querySelectorAll(selector).forEach(processElement);

  const observer = new MutationObserver(() => {
    document.querySelectorAll(selector).forEach(processElement);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

watchAndDeleteElements('.form__success-message');


// --- Empathy search: single sync point for all open/close paths ---
// Wraps window.open/closeEmpathySearch so any caller (trigger button,
// extended search X, drawer search) keeps every UI in sync: header brand
// class, trigger icon (search <-> X), and isOpen state.
(function () {
  try {
    const headerBrand = document.querySelector('.wt-header__brand');
    function syncSearchState(open) {
      if (headerBrand) headerBrand.classList.toggle('search--open', open);
      const trigger = window.empathySearchTrigger;
      if (trigger) {
        trigger.isOpen = open;
        if (typeof trigger.updateIcon === 'function') trigger.updateIcon(open);
      }
    }
    const originalOpen = window.openEmpathySearch;
    const originalClose = window.closeEmpathySearch;
    window.openEmpathySearch = function () {
      if (typeof originalOpen === 'function') {
        try { originalOpen.apply(this, arguments); } catch { }
      }
      syncSearchState(true);
    };
    window.closeEmpathySearch = function () {
      if (typeof originalClose === 'function') {
        try { originalClose.apply(this, arguments); } catch { }
      }
      syncSearchState(false);
    };
    // Safety: always reset on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.code === 'Escape') syncSearchState(false);
    });
  } catch { }
})();

// --- NaizFit: Trigger modal from the "What's my size" button ---
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-src="#modal-naizfit"]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const sheet = btn.closest('#sheet-size');
    const currentModal = btn.closest('modal-dialog');
    const container = currentModal ? currentModal.querySelector('.brn-modal__container') : null;

    // 1. Lanzamos NaizFit (capa superior)
    const naizBtn = document.getElementById('naiz-sizeform-opener');
    if (naizBtn) naizBtn.click();
    else if (typeof window.naiz_relaunch === 'function') window.naiz_relaunch();

    // 2a. Si viene del sheet de producto, lo cerramos directamente
    if (sheet && window.mobileSizeModal) {
      window.mobileSizeModal.close();
      return;
    }

    // 2b. Desvanecimiento suave del modal actual (400ms)
    if (container) {
      container.style.transition = 'opacity 0.4s ease-out';
      container.style.opacity = '0';
      container.style.pointerEvents = 'none';
    }

    setTimeout(() => {
      if (currentModal) {
        const closeBtn = currentModal.querySelector('.brn-modal__close');
        if (closeBtn) closeBtn.click();
      }
      if (container) {
        container.style.opacity = '';
        container.style.pointerEvents = '';
        container.style.transition = '';
      }
    }, 500);

  }, true);
})();

// --- NaizFit: Recommendation UI ---
(function () {
  const LS_KEY = 'naiz_recommended_size';

  function updateNaizfitUI(modal) {
    const naizfitDiv = modal.querySelector('[data-naizfit-ui]');
    if (!naizfitDiv) {
      console.log('[naizfit-ui] [data-naizfit-ui] not found in modal', modal.id);
      return;
    }

    let rec = '';
    try { rec = localStorage.getItem(LS_KEY) || ''; } catch (e) { }
    console.log('[naizfit-ui] updateNaizfitUI — modal:', modal.id, '— rec:', rec || '(none)');

    if (!rec) return; // No recommendation yet, keep default state

    // Check if recommended size is available in this modal (case-insensitive)
    const recLower = rec.toLowerCase();
    const matchingInput = Array.from(modal.querySelectorAll('input[data-size-value]'))
      .find(function (input) { return input.dataset.sizeValue.toLowerCase() === recLower; }) || null;
    const isAvailable = !!(matchingInput && !matchingInput.disabled);

    console.log('[naizfit-ui] rec=', rec, '| input found=', !!matchingInput, '| available=', isAvailable);

    // Build message from Liquid-rendered data attributes
    const txtTemplate = isAvailable
      ? (naizfitDiv.dataset.txtAvailable || '')
      : (naizfitDiv.dataset.txtUnavailable || '');
    const message = txtTemplate.replace('__SIZE__', rec);

    // Cache coat-hanger icon on first render (lost after innerHTML is replaced)
    const iconEl = naizfitDiv.querySelector('.svg-icon');
    if (iconEl) naizfitDiv._naizIconHTML = iconEl.outerHTML;
    const iconHTML = naizfitDiv._naizIconHTML || '';

    // Switch to recommendation state
    const openerEl = naizfitDiv.querySelector('#naiz-opener-container');
    naizfitDiv.classList.add('brn-sheet-size__naizfit--recommended');
    naizfitDiv.innerHTML =
      iconHTML +
      '<p class="brn-sheet-size__naizfit__message">' + message + '</p>';
    if (openerEl) naizfitDiv.appendChild(openerEl);

    // Change NaizFit's own button text to the translated "modify" label
    const naizBtn = document.getElementById('naiz-sizeform-opener');
    if (naizBtn) {
      const txtModify = naizfitDiv.dataset.txtModify || '';
      if (txtModify) naizBtn.textContent = txtModify;
    }

    // Highlight recommended size in list (only if available)
    modal.querySelectorAll('.brn-sheet-size__list__item').forEach(function (li) {
      li.classList.remove('is-recommended');
      const existing = li.querySelector('.variant-tooltip--recommended');
      if (existing) existing.remove();
    });
    if (matchingInput && isAvailable) {
      const li = matchingInput.closest('.brn-sheet-size__list__item');
      if (li) {
        li.classList.add('is-recommended');
        const txtRecommended = naizfitDiv.dataset.txtRecommended || '';
        if (txtRecommended) {
          const badge = document.createElement('div');
          badge.className = 'variant-tooltip variant-tooltip--recommended';
          badge.innerHTML = iconHTML + txtRecommended;
          const label = li.querySelector('.brn-sheet-size__label');
          if (label) label.appendChild(badge);
        }
      }
    }
  }

  // Debug helpers — useful to diagnose on first deploy without naizfit running
  window.__naizDebug = {
    updateUI: function () {
      const modal = document.querySelector('[data-cart-size-modal].is-open');
      if (modal) {
        updateNaizfitUI(modal);
      } else { console.log('[naizfit-ui] No open cart size modal. Open one first.'); }
    },
    getRec: function () { return localStorage.getItem(LS_KEY); },
    setRec: function (size) {
      localStorage.setItem(LS_KEY, size);
      console.log('[naizfit-ui] Recommendation set to "' + size + '". Call __naizDebug.updateUI() to refresh.');
    },
    clearRec: function () {
      localStorage.removeItem(LS_KEY);
      console.log('[naizfit-ui] Recommendation cleared.');
    }
  };
  console.log('[naizfit-ui] Debug: window.__naizDebug.setRec("XS"), .updateUI(), .getRec(), .clearRec()');

  // Update UI when a cart size modal is opened
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cart-size-modal-id]');
    if (!btn) return;
    setTimeout(function () {
      const modal = document.getElementById(btn.getAttribute('data-cart-size-modal-id'));
      if (modal && modal.classList.contains('is-open')) {
        updateNaizfitUI(modal);
      }
    }, 100);
  }, false);

  // Update UI when the product page mobile size sheet opens
  const sheetSize = document.getElementById('sheet-size');
  if (sheetSize) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && sheetSize.classList.contains('is-open')) {
          updateNaizfitUI(sheetSize);
        }
      });
    }).observe(sheetSize, { attributes: true });
  }

  // Override selectSize to capture naizfit recommendation
  function patchSelectSize() {
    if (
      !window.naizjs ||
      !window.naizjs.SizeForm ||
      typeof window.naizjs.SizeForm.prototype.selectSize !== 'function'
    ) {
      return false;
    }

    const orig = window.naizjs.SizeForm.prototype.selectSize;
    window.naizjs.SizeForm.prototype.selectSize = function (size) {
      console.log('[naizfit-ui] selectSize intercepted — size=', size);
      try { localStorage.setItem(LS_KEY, size); } catch (e) { }

      const result = orig.apply(this, arguments);

      // Update open cart size modal if any
      setTimeout(function () {
        const openModal = document.querySelector('[data-cart-size-modal].is-open');
        if (openModal) {
          console.log('[naizfit-ui] Updating open cart size modal after selectSize');
          updateNaizfitUI(openModal);
        }
      }, 200);

      return result;
    };

    console.log('[naizfit-ui] naizjs.SizeForm.prototype.selectSize patched successfully');
    return true;
  }

  let pollAttempts = 0;
  const maxPollAttempts = 60; // 30s at 500ms intervals
  var pollInterval = setInterval(function () {
    pollAttempts++;
    if (patchSelectSize()) {
      clearInterval(pollInterval);
    } else if (pollAttempts >= maxPollAttempts) {
      console.warn('[naizfit-ui] naizjs.SizeForm not available after 30s — selectSize not patched');
      clearInterval(pollInterval);
    }
  }, 500);
})();



function closeOthers(openedCollapsible) {
  document.querySelectorAll('.brn-product__info collapsible-section').forEach(el => {
    if (el !== openedCollapsible && el.dataset.open === 'true') {
      el.querySelector('.wt-collapse__trigger').click();
    }
  });
}

// Watch for attribute changes using MutationObserver
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'data-open'
    ) {
      const target = mutation.target;
      if (target.dataset.open === 'true') {
        closeOthers(target);
      }
    }
  });
});

// Observe all collapsibles
document.querySelectorAll('.brn-product__info collapsible-section').forEach(el => {
  observer.observe(el, { attributes: true });
});

// Clean tracking params and open cart drawer if ?showCart=true
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const shouldOpenCart = urlParams.get('showCart') === 'true';

  ['showCart', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (param) {
    urlParams.delete(param);
  });
  const cleanUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
  history.replaceState(null, '', cleanUrl);

  if (shouldOpenCart) {
    window.addEventListener('load', function () {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.toggleDrawerClasses === 'function' && !cartDrawer.isOpen) {
        cartDrawer.toggleDrawerClasses();
      }
    });
  }
})();
